import React, { Component } from 'react';
import { IoMdSearch } from 'react-icons/io';
import { withRouter } from 'react-router-dom';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import Input from '../../components/Input';
import host, { getLink } from '../../services/host';

import './style.css';
import ListPacientes from '../../components/ListPacientes';
import Button from '../../components/Button';
import { getStorage } from '../../utils/storage';
import { fetchApi } from '../../services/api';
import Loading from '../../components/Loading';

class InstitucionalPacientesPesquisador extends Component {
  constructor(props) {
    super(props);

    this.state = {
      busca: '',
      modal: null,
      nome_pesquisador: '',
      isLoading: false,
    };
  }

  componentDidMount() {
    document.title = `Pacientes do Aplicador`;
    window.scrollTo(0, 0);
    this.carregarDados();
  }

  carregarDados() {
    //ativa loading
    this.setState({
      isLoading: true,
    });

    fetchApi
      .get(
        process.env.REACT_APP_PESQUISADOR_GET,
        this.props.match.params.id_pesquisador,
      )
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            nome_pesquisador: response.data.dados.nome,
          });
        }
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  render() {
    return (
      <div id="institucional-pacientes-pesquisador">
        {this.state.isLoading ? <Loading /> : null}

        <Header />

        <div className="content">
          <TopPage
            title={`PACIENTES`}
            small={
              this.state.nome_pesquisador
                ? `Aplicador: ${this.state.nome_pesquisador}`
                : ''
            }
            back={getLink(`/dashboard`)}
            exportxls={`${host}/export-all-institucional/pesquisador/${this.props.match.params.id_pesquisador}?token=${getStorage('token')}`}
          />

          <Input
            placeholder="Buscar paciente"
            name="paciente"
            id="paciente"
            button={true}
            onChange={(e) => {
              this.setState({ busca: e.target.value });
            }}
          >
            <Button style={{ padding: '0px 10px' }}>
              <IoMdSearch />
            </Button>
          </Input>

          <ListPacientes
            nome={this.state.busca}
            id_pesquisador={this.props.match.params.id_pesquisador}
            readOnly={true}
          />
        </div>

        <Footer />

        {this.state.modal}
      </div>
    );
  }
}

export default withRouter(InstitucionalPacientesPesquisador);
